import { GenericAuthContext } from '@src/authContexts';
import React, { useContext } from 'react';

const WelcomeMessage: React.FC = () => {
  const { userDoc } = useContext(GenericAuthContext);
  const userData = userDoc.data();

  return (
    <aside>
      <h1 className='text-3xl font-bold mb-6'>
        HELLO {userData?.static.firstName.toUpperCase() ?? 'USER'},
      </h1>
      <p className='text-xl mb-6'>
        Welcome to your administrative portal. On the right, you will see outstanding items you must
        address, as well as any resources you have access to. If you have any questions, please
        contact the chief administrative officer, or, if the issue is related to technology, any
        director from the technology department.
      </p>
      <p>
        <i>
          Thank you for your service to the Youth Passion Project, <br></br> Youth Passion Project
          Technology
        </i>
      </p>
    </aside>
  );
};

export default WelcomeMessage;
